import { render, staticRenderFns } from "./ComplianceDialog.vue?vue&type=template&id=4bc996d8&"
import script from "./ComplianceDialog.vue?vue&type=script&lang=js&"
export * from "./ComplianceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports